import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { userSelectors } from '@wdx/clmi/api-services/services';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoleTypeEnum } from '../../../models/role-type.model';
import * as rootReducer from '../../../state/_setup/reducers';
import { RolesService } from '../roles/roles.service';
import { PrivilegesService } from '../privileges';
import { Privilege } from '@wdx/shared/utils';

@Injectable({
    providedIn: 'root',
})
export class AdministratorService {
    private store$: Store<rootReducer.State> = inject(Store);
    private roleService = inject(RolesService);
    private privilegesService = inject(PrivilegesService);

    isTenantAdminstrator$(): Observable<boolean> {
        return combineLatest([
            this.store$.select(userSelectors.isSystemAdminSelector),
            this.roleService.hasRole$(RoleTypeEnum.TenantAdministrator),
            this.privilegesService.hasPrivilege$(Privilege.TenantAdministrator),
        ]).pipe(
            map(
                ([isSystemAdmin, hasRole, isTenantAdmin]) =>
                    isSystemAdmin || hasRole || isTenantAdmin,
            ),
        );
    }
}
